export default {
  title: {
    fontWeight: 600,
    mb: 2,
  },
  logoPreview: {
    width: 100,
    height: 100,
    objectFit: 'contain',
    border: '1px solid #ddd',
    borderRadius: 1,
    p: 1,
  },
  btn: {
    bacgroundColor: '#4800F8',
  },
  alert: {
    fontWeight: 300,
    mb: 4,
  },
  editCardHeader: {
    backgroundColor: 'background.light',
    borderRadius: '4px 4px 0 0',
    px: 2,
    py: 1.75,
  },
  editCardHeaderText: {
    color: 'text.dark',
    fontWeight: '400',
  },
  editCardBody: {
    border: '1px solid',
    borderColor: 'background.grey.blue_3',
    borderTop: 'none',
    display: 'flex',
    gap: 3,
    px: 2,
    py: 2.5,
  },
  timeBox: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '107px',
  },
  boxesDivider: {
    backgroundColor: 'background.grey.blue_3',
    minWidth: '1px',
    width: '1px',
  },
  teamsBox: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    gap: 2.5,
  },
  teamBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    gap: 3,
  },
};
